@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.dynamic_applet {
  h1 {
    margin-top: 0;
    margin-bottom: 0.5em;
    padding-bottom: 0.1666666666em; // maps to 10px
    line-height: 112%;

    border-bottom: 0.0666666666em solid #f6f6f6; // maps to 4px
  }

  h2 {
    margin-bottom: 0.83333333em; // maps to 40px
    line-height: 112%;
  }

  .form {
    margin-top: 3.33333333em; // maps to 60px

    p {
      font-size: 1.11111111em; // maps to 20px
      line-height: 160%;
    }
  }

  .main-section-header {
    display: flex;
    justify-content: space-between;

    margin-top: 3em;

    h3 {
      margin: 0;
    }

    .icon {
      display: inline-block;
      width: 3em;
      height: 3em;
      vertical-align: middle;
      margin-left: 1em;
      margin-right: 0.5em;
      border-radius: 1.5em;

      img {
        width: 60%;
        height: 60%;
        margin: 20%;
      }
    }
  }

  .no-steps {
    margin-top: 2em;
    margin-left: 2em;
  }

  section.dynamic-applet-step {
    margin-top: 2em;

    header {
      border-radius: 0.75em 0.75em 0 0;
      padding: 1em 1em 1em 4.5em;
      color: #fff;

      .description {
        font-size: 1em;

        @include responsive.large-desktop-and-up {
          margin-left: 1.4em;
        }
      }
    }

    p.dynamic-applet-trigger-header {
      margin-bottom: 0;
    }

    .svg-icon svg {
      position: absolute;
      width: 1em;
      height: 1em;
      margin-top: 0.1em;
      margin-left: -1.4em;

      path {
        fill: #fff;
      }

      @include responsive.large-desktop-and-up {
        margin-left: -1.5em;
      }
    }

    .name {
      @include responsive.large-desktop-and-up {
        margin-left: 0.7em;
      }
    }

    article {
      border-radius: 0 0 0.75em 0.75em;
      padding: 1em 2em 0.1em 2em;
      background-color: colors.$secondary-background-color;

      h3 {
        margin-top: 0.5em;
        margin-bottom: 0;
      }

      p {
        display: inline-block;
      }

      ul {
        > li {
          font-weight: 700;
          margin-bottom: 2em;
        }

        ul > li {
          margin: 0.5em 0;
          font-weight: 500;
        }
      }
    }

    .field {
      margin: 1.5em 0;

      .label {
        font-size: 12px;
        font-weight: bold;
        color: #9b9b9b;

        span {
          margin-right: 10px;
          font-size: 1.5em;
          color: colors.$primary-text-color;
        }
      }

      .input {
        margin-top: 0.5em;

        textarea {
          font-weight: 500;
          font-size: 1em;
        }
      }

      .note {
        font-size: 0.875em;
        .text {
          color: colors.$secondary-text-color;
        }
        .spacing {
          margin-left: 0.25em;
        }
        a {
          color: colors.$primary-brand-color;
        }
      }
    }
  }

  .link {
    color: colors.$primary-brand-color;
  }

  .growing-text-area-container {
    font-size: 0.8em;

    &:not(.no-margin-top) {
      margin-top: 1.8em !important;
    }
  }

  &.logs {
    .fieldset {
      display: flex;
      width: 100%;

      .middle-element {
        margin-left: 1em;
        margin-right: 1em;
      }

      .search-box {
        margin-bottom: 1em;
      }

      div {
        flex-basis: auto;
        flex-grow: 1;
        margin-top: 0.5em;
        margin-bottom: 0.5em;
      }
    }

    .logs-table {
      .logs-column {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:nth-of-type(1) {
          width: 20%;
        }
        &:nth-of-type(2) {
          width: 55%;
        }
        &:nth-of-type(3) {
          width: 15%;
        }
        &:nth-of-type(4) {
          width: 10%;
        }
      }

      .logs-column-header {
        font-size: 1.1em;
        font-weight: bolder;
        &:nth-of-type(1) {
          padding-left: 0.5em;
        }
      }
    }

    .pagination {
      padding-top: 1em;
    }
  }

  &.review {
    form section {
      padding-top: 1em;

      border: 0 !important;
    }

    .feature-section-header {
      margin: 3.33333333em 0 2.22222222em 0; // maps to 60px
      // we will have to revisit this when including validation errors

      h2 {
        display: inline;
      }

      a.feature-explanation {
        text-decoration: underline;

        font-size: 0.888888888em; // maps to 16px
        color: colors.$secondary-text-color;

        margin-left: 2em;
        cursor: pointer;
      }
    }

    .column {
      display: flex;
      flex-direction: column;
      flex: 1;

      &.review-left {
        flex-basis: 50%;
      }

      &.review-icon {
        flex-basis: 10%;
        align-items: center;
        justify-content: center;
      }

      &.review-right {
        flex-basis: 30%;
      }
    }

    .runtime-script-container {
      margin-top: 3.33333333em; // maps to 60px
    }

    .design {
      display: flex;
      width: 100%;

      h3:not(:first-of-type) {
        margin-top: 2em;
      }

      .design-column {
        width: 100%;

        .label {
          font-size: 1.11111111em;
        }

        @media (min-width: 724px) {
          &:nth-of-type(2) {
            margin-left: 5%;
            width: 35%;
            min-width: 300px;
          }
        }
      }
    }

    .file-handler {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: fit-content;
    }

    .applet-background-upload-disabled {
      background: colors.$quaternary-text-color !important;
      color: colors.$primary-background-color !important;
      border: colors.$quaternary-text-color solid !important;
      cursor: not-allowed;
    }

    .test-results {
      border-radius: 0.5em;
      padding: 1em;
      &.success {
        background-color: colors.$test-success-color#{22};
        color: colors.$test-success-color;
      }
      &.failure {
        background-color: colors.$test-failure-color#{22};
        color: colors.$test-failure-color;
        p {
          color: colors.$primary-text-color;
        }
        g {
          stroke: colors.$test-failure-color;
        }
      }

      .header {
        display: flex;
        align-items: center;
      }

      svg {
        width: 16px;
        height: 16px;
        margin-right: 0.2em;
      }
    }
  }
}
